import { openDB } from "idb";
import { sm3, sm4 } from "sm-crypto-v2";
// @ts-ignore
const { FARM_NODE_ENV } = import.meta.env;
/**
 * 用户信息
 */
let userInfoKey = "",
  userMenuKey = "",
  comdCtKey = "",
  queryProcuementKey = "",
  queryATxtKey = "";

if (FARM_NODE_ENV === "prod") {
  userInfoKey = "09a0isdf90u";
  userMenuKey = "asdgadgq4ta";
  comdCtKey = "a4sb4fa17b6a";
  queryProcuementKey = "fasdgayg7yqyafha";
  queryATxtKey = "queryATxtKeyProd";
} else {
  userInfoKey = "accountInfo";
  userMenuKey = "userMenuKey";
  comdCtKey = "comdCtKey";
  queryProcuementKey = "queryProcuementKey";
  queryATxtKey = "queryATxtKey";
}

export const constData = {
  sm4Def: "0123456789abcdeffedcba9876543210",
};
/**
 * 页面从后端服务器获取的静态信息版本号
 */
export const viewVersion: any = {
  old: {},
  new: {},
};

/**
 * 图片服务器前缀
 */
export const baseImgUrl = {
  jd: "https://img13.360buyimg.com/n1/",
  me: "https://imgs.promise.pink/",
  gxjn: "https://imgs.promise.pink/",
};

// 打开数据库
const dbPromise = openDB("image-cache", 1, {
  upgrade(db) {
    db.createObjectStore("images", { keyPath: "url" });
  },
});

// 存储图片
export async function setImageToCache(url: string, blob: Blob): Promise<void> {
  const db = await dbPromise;
  await db.put("images", { url, blob });
}

// 获取图片
export async function getImageFromCache(url: string): Promise<Blob | undefined> {
  const db = await dbPromise;
  const item = await db.get("images", url);
  return item?.blob;
}

/**
 * 获取完整图片路径
 * @param opt
 * @returns
 */
export async function getImgUrl(opt: { type?: "jd" | "me" | "gxjn"; url: string }) {
  if (!opt.url) return;
  let lurl;
  //   console.log(opt);

  if (opt.url.startsWith("http://") || opt.url.startsWith("https://")) {
    lurl = opt.url;
    // return lurl;
  } else {
    // 如果是以 什么开头则返回 本系统的url
    lurl = baseImgUrl[opt.type || "me"] + opt.url;
  }

  //   console.log(2, lurl, opt);
  const hash = sm3(lurl);
  const blob = await getImageFromCache(hash);
  if (blob) {
    const blobUrl = URL.createObjectURL(blob);
    return blobUrl;
  }
  const st = setTimeout(async () => {
    try {
      const response = await fetch(lurl);
      if (!response.ok) {
        // console.error(
        //   `Failed to fetch image: ${response.status} ${response.statusText}`
        // );
        return lurl;
      } else {
        const blob = await response.blob();
        await setImageToCache(hash, blob);
      }
      clearTimeout(st);
    } catch (error) {
      //   console.error("Failed to fetch image:", error);
      return lurl;
    }
  }, 1000);
  return lurl;
}

/**
 * 清除所有本地存储的缓存
 */
export function clearAllLocalStorage(): void {
  try {
    localStorage.clear();
    // uni.clearStorageSync();
    ////////console.log("所有本地存储的缓存已清除");
  } catch (error) {
    console.error("清除 localStorage 时发生错误:", error);
  }
}
/**
 * 存储
 * @param key
 * @param value
 */
function setLocalStorage(key: string, value: any): void {
  console.log("=====================", key, value);

  try {
    // 如果 value 是一个对象，先将其转换为 JSON 字符串
    const valueToStore = JSON.stringify({ v: value });

    if (FARM_NODE_ENV === "prod") {
      // @ts-ignore
      localStorage.setItem(key, sm4.encrypt(valueToStore, constData.sm4Def));
    } else {
      console.log("=========111", key, value);

      localStorage.setItem(key, valueToStore);
    }
  } catch (error) {
    console.error("设置 localStorage 时发生错误:", error);
  }
}

/**
 * 读取
 * @param key
 * @returns
 */
function getLocalStorage<T>(key: string): T | null {
  // const value = uni.getStorageSync(key)
  const value = localStorage.getItem(key);
  try {
    // localStorage.getItem(key);
    if (value) {
      // 尝试将字符串解析为 JSON 对象
      // return JSON.parse(value) as T;
      //console.log("?????", key, value);
      if (FARM_NODE_ENV === "prod") {
        // @ts-ignore
        return JSON.parse(sm4.decrypt(value, constData.sm4Def)).v;
      } else {
        return JSON.parse(value).v as T;
      }
      // if ("production" === "development") {
      //   return JSON.parse(value).v as T;
      //   // return JSON.parse(sm4.decrypt(value, constData.sm4Def));
      // } else {
      //   // @ts-ignore
      //   return JSON.parse(sm4.decrypt(value, constData.sm4Def)).v;
      // }
    }
  } catch (error) {
    console.error("读取 localStorage 时发生错误:", error);
    clearAllLocalStorage();
    // navTo({
    //   url: '/pages/login/login'
    // })
    return null;
  }
  return null;
}

/**
 * 存储用户信息
 * @param outType
 */
export function setLocUserInfo(data: any) {
  setLocalStorage(userInfoKey, data || []);
}

/**
 * 获取用户信息
 */
export function getLocUserInfo(): any | null {
  let data = getLocalStorage<any>(userInfoKey);
  return data || {};
}

/**
 * 存储菜单信息
 * @param outType
 */
export function setUserMenu(data: any) {
  setLocalStorage(userMenuKey, data || []);
}

/**
 * 获取菜单信息
 */
export function getUserMenu(): any | null {
  let data = getLocalStorage<any>(userMenuKey);
  
  return data || {};
}

/**
 * 存储商品分类信息
 * @param outType
 */
export function setComdCt(data: any) {
  setLocalStorage(comdCtKey, data || []);
}

/**
 * 获取商品分类信息
 */
export function getComdCt(): any | null {
  let data = getLocalStorage<any>(comdCtKey);
  return data || [];
}

/**
 * 存储查询采购列表条件
 * @param outType
 */
export function setQueryProcuement(data: any) {
  setLocalStorage(queryProcuementKey, data || []);
}

/**
 * 查询采购列表条件
 */
export function getQueryProcuement(): any | null {
  let data = getLocalStorage<any>(queryProcuementKey);
  return data || null;
}

/**
 * 存储查询aTxt列表条件
 * @param data
 */
export function setQueryATxt(data: any) {
  setLocalStorage(queryATxtKey, data || []);
}

/**
 * 查询aTxt列表条件
 */
export function getQueryATxt(): any | null {
  let data = getLocalStorage<any>(queryATxtKey);
  return data || null;
}
